import React, {useCallback, useEffect, useState} from 'react';
import 'devextreme/data/odata/store';
import DataGrid, {
  Column,
  Pager,
  Paging,
  FilterRow,
  Selection,
  Button as GridButton
} from 'devextreme-react/data-grid';
import {Button} from "devextreme-react/button";
import './my-gpts.scss';
import {Popup} from "devextreme-react/popup";
import NewGPT from "../../components/new-gpt/new-gpt";
import {useIsMount} from "../../utils/isMountHook";
import {useApi, apiUrl} from "../../api/api-methods";
import {useNavigate} from "react-router";
import {useAuth} from "../../contexts/auth";
import notify from "devextreme/ui/notify";

export default function MyGPTs() {
  const isMount = useIsMount();
  const api = useApi();
  const navigate = useNavigate();
  const {user} = useAuth();

  const [popupVisible, setPopupVisible] = useState(false);
  const [gptsData, setGptsData] = useState([]);
  const [selectedGpt, setSelectedGpt] = useState(null);

  // methods
  function onInit() {
    async function asyncSpace() {
      await fetchData();
    }

    void asyncSpace();
  }

  async function fetchData() {
    const result = await api.context.getAll();
    setGptsData(result);
  }

  const newGpt = useCallback(() => {
    setSelectedGpt(null);
    setPopupVisible(true);
  }, [setPopupVisible]);

  const handlePopupHidden = useCallback(() => {
    setPopupVisible(false);
  }, [setPopupVisible]);

  const onUseGptClick = useCallback((e) => {
    const row = e.row.data;
    e.event.preventDefault();
    console.log('Use GPT', row);
  }, []);

  const onSelectionChanged = useCallback(({selectedRowsData}) => {
    const data = selectedRowsData[0];
    navigate(`/home/?my-gpt=${data.id}&my-gpt-name=${data.name}`);
    console.log('Selected GPT', data);
  }, []);

  function editGpt(e) {
    const row = e.row.data;
    console.log('Edit GPT', row, user);
    if (row.userId !== user.id) {
      notify(`You are not the author of GPT ${row.name}. You can not edit this GPT model.`, 'error', 4000);
      return;
    }
    setSelectedGpt(row);
    setPopupVisible(true);
  }

  function removeGpt(e) {
    const row = e.row.data;
    console.log('Remove GPT', row);
    if (!window.confirm('Are you sure you want to remove this GPT model?')) {
      return;
    }
    if (row.userId !== user.id) {
      notify(`You are not the author of GPT ${row.name}. You can not remove this GPT model.`, 'error', 4000);
      return;
    }
    api.context.deleteContext(row.id)
      .then(() => fetchData())
      .catch((err) => notify(err, 'error', 4000));
  }

  // effects
  useEffect(onInit, []);

  return (
    <React.Fragment>
      <div className="responsive-paddings my-gpts">
        <h2 className={'content-block'}>My GPTs</h2>
        <Button type="default"
                stylingMode="contained"
                disabled={false}
                text="New GPT"
                onClick={newGpt}>
        </Button>
        <div className="toolbar">
          <DataGrid
            className={'dx-card wide-card'}
            dataSource={gptsData}
            showBorders={false}
            //focusedRowEnabled={true}
            columnAutoWidth={true}
            columnHidingEnabled={true}
            hoverStateEnabled={true}
            keyExpr={'id'}
            onSelectionChanged={onSelectionChanged}
          >
            <Selection mode="single"/>
            <Paging defaultPageSize={10}/>
            <Pager showPageSizeSelector={true} showInfo={true}/>
            <FilterRow visible={true}/>

            <Column dataField={'id'} dataType="number"/>
            <Column dataField={'name'} dataType="string"/>
            <Column dataField={'authorName'} dataType="string"/>
            <Column dataField={'embeddingModel'} dataType="string"/>
            <Column dataField={'created'} dataType="datetime"/>

            <Column type="buttons" width={110}>
              <GridButton hint="Edit" icon="edit" disabled={false} onClick={editGpt}/>
              <GridButton hint="Remove" icon="remove" disabled={false} onClick={removeGpt}/>
            </Column>

          </DataGrid>
          <div>
            <Popup
              width={'80%'}
              height={'90%'}
              showTitle={true}
              title={!!selectedGpt ? `Editing "${selectedGpt.name}"` : 'New Custom GPT'}
              resizeEnabled={true}
              dragEnabled={true}
              hideOnOutsideClick={true}
              visible={popupVisible}
              onHiding={handlePopupHidden}
              showCloseButton={true}
              deferRendering={false}
            >
              <NewGPT popupVisibilityFn={setPopupVisible}
                      dataFetchFn={fetchData}
                      selectedGpt={selectedGpt}
                      popupVisible={popupVisible}/>
            </Popup>
          </div>
        </div>
      </div>
    </React.Fragment>
  )
}